<template>
  <div class="mobile-main-menu">
    <div class="mobile-main-menu-item" v-for="(item, index) in mainMenuItems" :key="index">
      <a @click="handleMenuClick(item)" class="menu-link" href="javascript:void(0)">
        <img :src="item.icon" :alt="item.name" class="menu-icon" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileMainMenu',
  props: {
    mainMenuItems: {
      type: Array,
      required: true,
      default: () => []
    },
    user: {
      type: [Object, Array],
      default: () => null
    }
  },
  data() {
    return {
      protectedRoutes: ['/cashback', '/event', '/partner', '/continue']
    }
  },
  methods: {
    handleMenuClick(item) {
      const isProtected = this.protectedRoutes.includes(item.path)
      const isLoggedIn = this.user && (Array.isArray(this.user) ? this.user.length > 0 && this.user[0].key : this.user.key)
      
      if (isProtected && !isLoggedIn) {
        // Show login modal for protected routes when not logged in
        const loginModal = document.getElementById('loginModal')
        if (loginModal) {
          const modal = new bootstrap.Modal(loginModal)
          modal.show()
        } else {
          // Fallback: try jQuery if bootstrap is not available
          if (window.$ && window.$('#loginModal').length) {
            window.$('#loginModal').modal('show')
          } else {
            // Final fallback: trigger modal via data attributes
            const modalTrigger = document.querySelector('[data-target="#loginModal"]')
            if (modalTrigger) {
              modalTrigger.click()
            }
          }
        }
      } else {
        // Navigate to route (either public route or user is logged in)
        this.$router.push(item.path)
      }
    }
  }
}
</script>

<style scoped>
.mobile-main-menu {
  position: sticky;
  top: 0;
  margin: 15px 0px 0px 0px;
  display: flex;
  justify-content: center;
  overflow-x: auto;
}

.mobile-main-menu-item {
  min-width: 100px;
  text-align: center;
  padding: 8px;
  border-radius: 8px;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.mobile-main-menu-item:hover {
  background: linear-gradient(145deg, #DF4818, #00cc66);
  transform: translateY(-2px);
}

.menu-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.3s ease;
}

.menu-link:hover {
  color: #000000;
  text-decoration: none;
  cursor: pointer;
}

.menu-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 0;
}

.menu-text {
  display: none;
}

@media (max-width: 768px) {
  .mobile-main-menu {
    margin: 0px 0px 0px 0px;
  }
  
  .mobile-main-menu-item {
    min-width: 40px;
    padding: 6px;
  }

  .menu-text {
    font-size: 10px;
  }

  .menu-icon {
    width: 50px;
    height: 50px;
  }
}
</style>